import { render, staticRenderFns } from "./RecentLiteratureBrowse.vue?vue&type=template&id=8c8127d4&scoped=true"
import script from "./RecentLiteratureBrowse.vue?vue&type=script&lang=js"
export * from "./RecentLiteratureBrowse.vue?vue&type=script&lang=js"
import style0 from "./RecentLiteratureBrowse.vue?vue&type=style&index=0&id=8c8127d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8127d4",
  null
  
)

export default component.exports